import request from "@/utils/request";

export function userInfo() {
    return request({
        url: '/app/user/info',
        method: 'post'
    })
}

export function userInfoBind() {
    return request({
        url: '/app/user/info-bind',
        method: 'post'
    })
}

export function userUpdate(data) {
    return request({
        url: '/app/user/update',
        method: 'post',
        data
    })
}

export function sendCode(data) {
    return request({
        url: '/auth2/send_code',
        method: 'post',
        data
    })
}

export function getDetail(params) {
    return request({
        url: '/app/user/info/get',
        method: 'get',
        params
    })
}

export function saveDetail(data) {
    return request({
        url: '/app/user/info/save',
        method: 'post',
        data
    })
}

export function getDeleteDetail(params) {
    return request({
        url: '/app/user/delete/get',
        method: 'get',
        params
    })
}

export function submitDeleteDetail(data) {
    return request({
        url: '/app/user/delete/submit',
        method: 'post',
        data
    })
}

export function submitDetail(data) {
    return request({
        url: '/app/user/info/submit',
        method: 'post',
        data
    })
}

export function userCheckNotice(data) {
    return request({
        url: '/app/user/check-notice',
        method: 'post',
        data
    })
}

export function checkService(name) {
    return request({
        url: '/app/user/check/service',
        method: 'get',
        params: {serviceName: name}
    })
}

export function bindPersonnel(data) {
    return request({
        url: '/app/user/bind_personnel',
        method: 'post',
        data
    })
}

export function bindPersonnelPreview(data) {
    return request({
        url: '/app/user/bind_personnel_preview',
        method: 'post',
        data
    })
}
